import { Box } from '@customerio/pluma-components/react';
import { useSignupPublicFlags } from '@/services/signup/public-flags';
import { hasSignupPublicFlag, SignupPublicFeatureFlag } from '@/services/signup/public-flags-store';
import { SignupShell } from './components/signup-shell';
import { PostRegistrationWait } from './post-registration-wait';
import { resolveSignupColorScheme } from './utils/signup-color-scheme';
import type { SignupCompletion } from './types';

type PostRegistrationHoldProps = {
  completion: SignupCompletion;
};

/**
 * The post-register hold keeps the funnel's shell. The flow provider is gone
 * after the session flip, so the scheme is re-derived from the flags and the
 * completion; without it the page dropped to a bare loader on the ambient
 * theme — a visible flash when the hold is a single request.
 */
export function PostRegistrationHold({ completion }: PostRegistrationHoldProps) {
  const flags = useSignupPublicFlags();
  const scheme = resolveSignupColorScheme({
    isStartup: completion.isStartup,
    isSignupDarkModeEnabled: hasSignupPublicFlag(flags, SignupPublicFeatureFlag.SignupDarkMode),
  });

  return (
    <SignupShell scheme={scheme} isStartupFormStep={false} showLoginLink={false}>
      <Box
        as="main"
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: 'calc(100vh - 40px)' }}
      >
        <PostRegistrationWait completion={completion} />
      </Box>
    </SignupShell>
  );
}
